module.exports = __webpack_public_path__ + "static/media/features7.cc4b01c8.jpg";